import { AuthUserProfile } from '../Auth/authTypes';
import { AddNewServiceCallRequestDto } from '../../API/support/dto/request/add-new-service-call.request.dto';

export const createNewServiceCallDataDto = (
  data: createNewServiceCallDataType,
  profile: AuthUserProfile,
  files: string[]
): AddNewServiceCallRequestDto => {
  const user = {
    id: profile?.id!,
    name: profile?.fullName || '',
    email: profile?.email || '',
    phone: profile?.phone || '',
    company_id: profile?.company?.id!,
    company_name: profile?.company?.name!,
    space_id: profile?.company?.spaces?.[0]!,
  };
  return {
    message: data.message,
    subject: data.subject,
    category_code: data.categoryCode,
    sub_category_code: data.subCategoryCode,
    building_code: data.buildingVisitId,
    space_code: data.spaceVisitId,
    files,
    user,
  };
};

export interface createNewServiceCallDataType {
  buildingVisitId: string;
  spaceVisitId: string;
  categoryCode: string;
  subCategoryCode: string;
  message: string;
  subject: string;
}
